module.exports = __webpack_public_path__ + "static/media/garden.3ecdb554.webp";